import React from "react";
import "./styles.css";
import { Typography, Grid } from "@mui/material";
import Button from "../Button";
import { useNavigate } from "react-router-dom";
import moment from "moment";

export default function Card({ data, showTitle }) {
  const navigate = useNavigate();

  const formatDateTime = (dateTime) => {
    return moment(dateTime).format("MMM D, YYYY [at] h:mm A");
  };

  const handleViewDetails = () => {
    if (data.status === "COMPLETED") {
      navigate(`/ViewInvoice/${data.id}`);
    } else if (data.status === "IN_PROGRESS") {
      navigate(`/PauseOrPayJob/${data.id}`);
    } else {
      navigate(`/job-details/${data.id}`);
    }
  };

  return (
    <Grid>
      {showTitle && (
        <Typography pt={2} pb={1} color="rgba(114, 114, 114, 1)">
          Job no #{data.id}
        </Typography>
      )}

      <Grid className="box-matchingJobs-card">
        <Grid className="card-img-section">
          <Grid>
            <img 
              className="card-img" 
              src={data.imageurl} 
              alt={`${data.name}`} 
            />
          </Grid>
          <Typography
            id="two-lines-text-css"
            textAlign="center"
            fontSize="13px"
            marginTop="10px"
            maxWidth="80%"
            fontWeight="bold"
          >
            {data.name}
          </Typography>
          <Typography fontSize="11px" id="two-lines-text-css">
            {data.status}
          </Typography>
        </Grid>
        <Grid width="65%" position="relative" p={2}>
          <Typography fontSize="14px" color="rgba(114, 114, 114, 1)">
            Rating: {data.rating || "4"}
            <span
              style={{
                fontWeight: "bold",
                color: "black",
              }}
            >
              {" "}★
            </span>
          </Typography>

          <Grid
            mb={1}
            mt={1}
            display="flex"
            justifyContent="space-between"
            alignItems="center"
          >
            <Typography fontWeight="bold" fontSize="11px">
              <span
                style={{
                  fontWeight: "400",
                  color: "rgba(114, 114, 114, 1)",
                }}
              >
                Date & Time:{" "}
              </span>
              {formatDateTime(data.scheduledTime)}
            </Typography>
          </Grid>
          <Typography color="rgba(114, 114, 114, 1)" fontSize="14px">
            Looking for:{" "}
          </Typography>
          <Typography
            pb={2}
            fontSize="14px"
            style={{
              lineHeight: 1.2,
            }}
          >
            {data.description}
          </Typography>
          <Grid>
            <Button
              name="View Details"
              onClick={handleViewDetails}
            />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}